import { createSelector } from '@reduxjs/toolkit';
import { selectors as dataGridTableSelectors } from '../Modules/siteDataGridTable';
import { selectors as siteVisitorSelectors } from '../Modules/typeOfPersonnel';
import { selectors as filterSelectors } from '../Modules/siteFilters';
import { transform as siteListTransform } from 'utils/DataTransform/Sites/SitesList';
import { transform as siteDetailsTransform } from 'utils/DataTransform/Sites/SiteDetails';
import { getGlobalDepartments } from 'utils/personnelHelper';
import { getGlobalDepartmentRecords } from 'selectors/globalSelectors';
import isEmpty from 'lodash/isEmpty';
import { transformVisitorList } from 'utils/DataTransform/Visitor/VisitorList';
import { getSecurityCompanyServices } from 'reducers/securityCompany';
import { getTimezone } from 'reducers/utils';
import { selectors as embeddedFormSelectors } from 'modules/embeddedForms/reducer';
import { getItemOrDefaultToValue } from 'utils/details';
//--------------------- Generic Selectors ---------------------------------------
export const getTotalEntries = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => {
    if (!rowsCount) {
      return 0;
    }
    return rowsCount;
  },
);
// status of list refresh
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);

export const getSelectedRowID = createSelector(
  dataGridTableSelectors.getSelectedRowID,
  selectedRowID => selectedRowID,
);
export const getFilters = createSelector(
  filterSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);
export const getSiteFilterKey = createSelector(
  filterSelectors.getFilterKey,
  key => {
    return key;
  },
);
//-------------------------Specific Selectors ------------------------------

export const getSiteListTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  getGlobalDepartmentRecords,
  (list, globalDepartmentRecords) => {
    if (isEmpty(list)) return [];
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    return siteListTransform(list, globalDepartmentList);
  },
);
export const getSiteListRaw = createSelector(
  dataGridTableSelectors.getGridTableList,
  list => {
    if (isEmpty(list)) return [];
    return list;
  },
);
export const getSiteVisitorList = createSelector(
  siteVisitorSelectors.getSiteVisitorList,
  siteVisitorList => siteVisitorList,
);
export const getSiteDetailsTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getGlobalDepartmentRecords,
  getTimezone,
  getSiteVisitorList,
  getSecurityCompanyServices,
  (details, globalDepartmentRecords, timezone, siteVisitorList, services) => {
    if (isEmpty(details)) {
      return {};
    }
    // convert it into id and name list array
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    const transformSiteVisitorList = transformVisitorList(
      siteVisitorList,
      timezone,
    );
    return siteDetailsTransform({
      data: details,
      visitors: transformSiteVisitorList,
      globalDepartmentList,
      businessClientList: [],
      /**
       *TODO: Not implemented yet
       */ services,
    });
  },
);
export const getSiteDetailsRaw = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getGlobalDepartmentRecords,
  getTimezone,
  getSiteVisitorList,
  getSecurityCompanyServices,
  (details, globalDepartmentRecords) => {
    if (isEmpty(details)) {
      return {};
    }
    // convert it into id and name list array
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);

    const selectedDepartments = globalDepartmentList.filter(f =>
      getItemOrDefaultToValue(details, 'departmentIds', []).includes(f.id),
    );
    return { ...details, departments: selectedDepartments };
  },
);
// embeddedForm selectors
// businessClient
export const businessClientEmbeddedDetails = createSelector(
  embeddedFormSelectors.getBusinessClientEmbeddedFormDetails,
  details => {
    return details;
  },
);
//clients/customers
export const customerEmbeddedDetails = createSelector(
  embeddedFormSelectors.getCustomersEmbeddedFormDetails,
  details => {
    return details;
  },
);
//sites
export const siteEmbeddedDetails = createSelector(
  embeddedFormSelectors.getSitesEmbeddedFormDetails,
  getGlobalDepartmentRecords,
  (details, globalDepartmentRecords) => {
    if (isEmpty(details)) {
      return {};
    }
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    const [transformedEmbeddedSite] = siteListTransform(
      [details],
      globalDepartmentList,
    );
    return transformedEmbeddedSite;
  },
);
